// extracted by mini-css-extract-plugin
export default {"goods":"goods_goods__BloW1"};